import axios from "axios";
// DOCS - <apiURL>/docs
const apiURL = "https://marketnews.nextrades.ai";
// const apiURL = "http://127.0.0.1:8000";

const lang = localStorage.getItem("language") || "en";
const headers = {Accept: "application/json"};

export async function getMarketNews(payload) {
    try {
        const response = await axios.post(`${apiURL}/news`, {...payload, language: lang}, {
            headers
        })
        return response?.data
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function getRecentNews() {
    try {
        const response = await axios.get(`${apiURL}/recent-news`, {
            params: {language: lang},
            headers
        })
        return response?.data
    } catch (e) {
        console.error(e);
        throw e;
    }
}